import Vue                  from 'vue'
import cryptoSignInfoPage   from '@/components/pages/crypto-sign-info-page.vue'
import store                from '../services/store/crypto-sign-info-store'


if(!window.VUE_EVENT_BUS_CRYPTO_SIGN_INFO) {
  window.VUE_EVENT_BUS_CRYPTO_SIGN_INFO = new Vue();
}

new Vue({
  store,
  render: h => h(cryptoSignInfoPage)
}).$mount('#vue-js-crypto-sign-info')